import { render, staticRenderFns } from "./SidebarNavSubItem.vue?vue&type=template&id=13f36b87&scoped=true"
import script from "./SidebarNavSubItem.vue?vue&type=script&lang=js"
export * from "./SidebarNavSubItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavSubItem.vue?vue&type=style&index=0&id=13f36b87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f36b87",
  null
  
)

export default component.exports